import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

export default function salvarPontosEmbarque(comando) {
  const url = `${URL}/ponto-embarque/cadastrar`
  return () => axios.post(url, comando, SLOW_REQUEST_CONFIG)
}
